exports = module.exports = require("../../../../../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._3ZbftTc5EmFrsaAxH9yXLF{color:\"[theme:themeDark, default:#0D62AA]\";height:39px;line-height:39px;cursor:pointer;font-family:Segoe UI Symbol,\"Segoe UI Web (West European)\",Segoe UI,-apple-system,BlinkMacSystemFont,Roboto,Helvetica Neue,sans-serif}html[dir] ._3ZbftTc5EmFrsaAxH9yXLF{background-color:\"[theme:neutralLighterAlt, default:#faf9f8]\";border-bottom:1px solid \"[theme:neutralLight, default:#edebe9]\"}", ""]);
// Exports
exports.locals = {
	"groupHeader": "_3ZbftTc5EmFrsaAxH9yXLF"
};